import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { SIGNIN_URL } from "../ApiUrls";

export default class SigninRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    credential: "",
    password: "",
  };

  constructor(userDetail) {
    super();
    this.body.credential = userDetail.credential;
    this.body.password = userDetail.password;
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return SIGNIN_URL;
  };

  getBody = () => {
    return this.body;
  };
}
